export const CapaActionSchema: any = {
    title:"",
    owner:[],
    targetDate:"",
    description:"",
    // activityComments:"",
    // activityDate:"",
    // actionItemStatus :"",
    referenceId:"",
    locationId:"",
    organizationId:"",
    id:"",
    status:true,
}